import getTime from 'date-fns/getTime';
import addMinutes from 'date-fns/addMinutes';

import QuizService from '../../services/quizService';

import quizContent from '../../../content/quiz.json';
import randomArray from '../../utils/randomArray';
import groupBy from '../../utils/groupBy';

export const QUIZ_START = 'QUIZ_START';
export const QUIZ_ANSWER = 'QUIZ_ANSWER';
export const QUIZ_ERROR = 'QUIZ_ERROR';
export const QUIZ_NEXT = 'QUIZ_NEXT';
export const QUIZ_END = 'QUIZ_END';
export const QUIZ_RESTART = 'QUIZ_RESTART';
export const QUIZ_DIPLOMA = 'QUIZ_DIPLOMA';

function getRandomQuestions(questions, numberOfQuestions) {
  // get random items possibly equaly from every category
  const [categories, categorizedQuestions] = groupBy(questions, element => element.category);
  const results = [];
  let removedGroups = 0;

  while (results.length < numberOfQuestions && categorizedQuestions.length > 0) {
    const groupIndex = Math.max(0, results.length - removedGroups) % categorizedQuestions.length;
    const questionIndex = Math.floor(Math.random() * categorizedQuestions[groupIndex].length);
    results.push(categorizedQuestions[groupIndex].splice(questionIndex, 1)[0]);

    if (categorizedQuestions[groupIndex].length === 0) {
      categorizedQuestions.splice(groupIndex, 1);
      removedGroups += 2;
    }
  }

  // get totally random items
  // const shuffled = questions.sort(() => 0.5 - Math.random());
  // const results = shuffled.slice(0, 10);

  return results;
}

function sendAnswers(id, validAnswers, percentage, questionsForClass, questionsForStudent) {
  const passed = percentage >= quizContent.successTreshold;
  const answers = questionsForClass.map(question => {
    const drawnQuestion = questionsForStudent.find(sourceQuestion => sourceQuestion.id === question.id);

    if (!drawnQuestion) {
      return null;
    }

    switch (drawnQuestion.type) {
      case 'single':
      case 'true-or-false':
        if (drawnQuestion.checked.length && drawnQuestion.checked[0].valid) {
          return 1;
        } else {
          return 0;
        }
        break;
      default:
        return null;
        break;
    }
  });

  QuizService.saveAnswers({ id, validAnswers, passed, answers });
}

export function quizStart({ schoolCode, classNumber, studentId }) {
  const date = new Date();

  // Add indexes
  const questionsForClass = quizContent.questions
    .filter(question => {
      return question.classes.includes(classNumber);
    })
    .map((question, index) => {
      return {
        ...question,
        id: index + 1,
      };
    });

  // Add checked array
  const questionsForStudent = getRandomQuestions(questionsForClass, quizContent.numberOfQuestions).map(question => {
    return {
      ...question,
      checked: [],
    };
  });

  return {
    type: QUIZ_START,
    payload: {
      startTime: getTime(date),
      endTime: getTime(addMinutes(date, quizContent.time)),
      schoolCode,
      classNumber,
      studentId,
      questionsForClass,
      questionsForStudent,
    },
  };
}

export function quizAnswer({ answer }) {
  return {
    type: QUIZ_ANSWER,
    payload: { answer },
  };
}

export function quizNext() {
  return (dispatch, getState) => {
    const state = getState();
    const question = state.root.quiz.question;
    const questions = state.root.quiz.questions;

    switch (question.type) {
      case 'single':
      case 'true-or-false':
        if (!question.checked.length) {
          dispatch({
            type: QUIZ_ERROR,
            payload: {
              error: 'Musisz zaznaczyć jedną odpowiedź',
            },
          });
        } else {
          const questionIndex = questions.findIndex(q => q.id === question.id);
          const questionNextIndex = questionIndex + 1;

          if (questions.length > questionNextIndex) {
            dispatch({
              type: QUIZ_NEXT,
              payload: {
                questionIndex: questionNextIndex,
                question: questions[questionNextIndex],
              },
            });
          } else {
            dispatch(quizEnd());
          }
        }
        break;
      default:
        break;
    }
  };
}

export function quizEnd() {
  return (dispatch, getState) => {
    const state = getState();
    const finishTime = getTime(new Date());
    const studentId = state.root.auth.studentId;
    const questions = state.root.quiz.questions;
    const questionsForClass = [...state.root.quiz.questionsForClass];
    const questionsForStudent = [...state.root.quiz.questionsForStudent];

    // Update Questions Collection
    questions.forEach(sourceQuestion => {
      const questionIndex = questionsForStudent.findIndex(destQuestion => destQuestion.id === sourceQuestion.id);
      questionsForStudent[questionIndex] = sourceQuestion;
    });

    // Calculate validAnswers and Percentage
    let validAnswers = 0;

    for (let i = 0; i < questionsForStudent.length; i++) {
      const question = questionsForStudent[i];
      const valid = question.checked.some(answer => {
        return answer.valid;
      });

      if (valid) {
        validAnswers += 1;
      }
    }

    const percentage = Math.round((validAnswers / questionsForStudent.length) * 100);

    sendAnswers(studentId, validAnswers, percentage, questionsForClass, questionsForStudent);

    dispatch({
      type: QUIZ_END,
      payload: {
        finishTime,
        validAnswers,
        percentage,
        questionsForStudent,
      },
    });
  };
}

export function quizRestart() {
  return (dispatch, getState) => {
    const state = getState();
    const date = new Date();
    const validAnswers = state.root.quiz.validAnswers;
    const questions = state.root.quiz.questions;
    const correctionNumber = Math.ceil((quizContent.numberOfQuestions * quizContent.successTreshold) / 100) - validAnswers;
    const invalidQuestions = questions.filter(question => question.checked.some(answer => !answer.valid) || !question.checked.length);
    const questionsToBeCorrected = randomArray(invalidQuestions, correctionNumber);
    const timeForCorrection = correctionNumber * quizContent.correctionTime;

    dispatch({
      type: QUIZ_RESTART,
      payload: {
        startTime: getTime(date),
        endTime: getTime(addMinutes(date, timeForCorrection)),
        questions: questionsToBeCorrected,
      },
    });
  };
}

export function diplomaDownloaded() {
  return (dispatch, getState) => {
    dispatch({
      type: QUIZ_DIPLOMA,
    });
  };
}
